import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-a6f90e9e"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "footer-container"
};
var _hoisted_2 = {
  class: "is-flex"
};
var _hoisted_3 = {
  class: "footer-container--item"
};
var _hoisted_4 = {
  class: "footer-container--item"
};
var _hoisted_5 = {
  class: "footer-container--item"
};
var _hoisted_6 = {
  key: 0,
  class: "footer-container--item"
};
var _hoisted_7 = {
  key: 1,
  class: "footer-container--item"
};
var _hoisted_8 = {
  class: "footer-container--item"
};
var _hoisted_9 = {
  class: "footer-container--item"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_SvgIcon = _resolveComponent("SvgIcon");

  var _component_el_button = _resolveComponent("el-button");

  var _component_Products = _resolveComponent("Products");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
    size: "large",
    class: "has-background-light is-full-width bottom-menu-btn d-flex fl-start",
    onClick: _ctx.onClickCustomers
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_SvgIcon, {
        iconContent: _ctx.customerIconContent,
        iconAlt: _ctx.customerIconAlt,
        iconStyle: _ctx.iconStyle,
        "data-cy": "customers-button"
      }, null, 8, ["iconContent", "iconAlt", "iconStyle"]), _createTextVNode(" " + _toDisplayString(_ctx.$t("button.customers")), 1)];
    }),
    _: 1
  }, 8, ["onClick"])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
    size: "large",
    class: "has-background-light is-full-width bottom-menu-btn d-flex fl-start",
    onClick: _ctx.onClickProducts,
    "data-cy": "products-table-button"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_SvgIcon, {
        iconContent: _ctx.productIconContent,
        iconAlt: _ctx.productIconAlt,
        iconStyle: _ctx.iconStyle
      }, null, 8, ["iconContent", "iconAlt", "iconStyle"]), _createTextVNode(" " + _toDisplayString(_ctx.$t("button.products")), 1)];
    }),
    _: 1
  }, 8, ["onClick"]), true ? (_openBlock(), _createBlock(_component_Products, {
    key: 0
  })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
    size: "large",
    class: "has-background-light is-full-width bottom-menu-btn d-flex fl-start",
    onClick: _ctx.onClickOrders
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_SvgIcon, {
        iconContent: _ctx.orderIconContent,
        iconAlt: _ctx.orderIconAlt,
        iconStyle: _ctx.iconStyle,
        "data-cy": "orders-table-button"
      }, null, 8, ["iconContent", "iconAlt", "iconStyle"]), _createTextVNode(" " + _toDisplayString(_ctx.$t("button.orders")), 1)];
    }),
    _: 1
  }, 8, ["onClick"])]), !_ctx.hideReports ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_el_button, {
    size: "large",
    class: "has-background-light is-full-width bottom-menu-btn d-flex fl-start",
    onClick: _ctx.onClickAnalytics
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_SvgIcon, {
        iconContent: _ctx.analyticsIconContent,
        iconAlt: _ctx.analyticsIconAlt,
        iconStyle: _ctx.iconStyle,
        "data-cy": "analytics-button"
      }, null, 8, ["iconContent", "iconAlt", "iconStyle"]), _createTextVNode(" " + _toDisplayString(_ctx.$t("button.analytics")), 1)];
    }),
    _: 1
  }, 8, ["onClick"])])) : _createCommentVNode("", true), !_ctx.hideReports ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_el_button, {
    size: "large",
    class: "has-background-light is-full-width bottom-menu-btn d-flex fl-start",
    onClick: _ctx.onClickReport,
    "data-cy": "report-button"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_SvgIcon, {
        iconContent: _ctx.reportIconContent,
        iconAlt: _ctx.reportIconAlt,
        iconStyle: _ctx.iconStyle
      }, null, 8, ["iconContent", "iconAlt", "iconStyle"]), _createTextVNode(" " + _toDisplayString(_ctx.$t("button.cashier-report")), 1)];
    }),
    _: 1
  }, 8, ["onClick"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_button, {
    size: "large",
    class: "has-background-light is-full-width bottom-menu-btn d-flex fl-start",
    onClick: _ctx.onClickCalendar
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_SvgIcon, {
        iconContent: _ctx.orderIconContent,
        iconAlt: _ctx.orderIconAlt,
        iconStyle: _ctx.iconStyle,
        "data-cy": "occupancy-calendar-button"
      }, null, 8, ["iconContent", "iconAlt", "iconStyle"]), _createTextVNode(" " + _toDisplayString(_ctx.$t("button.occupancy-calendar")), 1)];
    }),
    _: 1
  }, 8, ["onClick"])]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
    size: "large",
    class: "has-text-light has-background-primary is-full-width bottom-menu-btn-green",
    onClick: _ctx.onClickOpenDrawer
  }, {
    default: _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$t("button.open-drawer").toUpperCase()), 1)];
    }),
    _: 1
  }, 8, ["onClick"])])])]);
}